export const MainAppRoutes = {
	MANAGEMENT: 'management/',
	APP: '',
}

export const AppRoutes = {
	TABS: 'app',
	TAB_TODAY: 'today',
	TAB_BOOK: 'book',
	TAB_COWORKERS: 'coworkers',
	TAB_MORE: 'more',
	
	AUTH_DOMAIN: 'domain',

	PUSH_NOTIFICATIONS: 'push_notifications',
	NOTIFICATIONS: 'notifications',

	// Pages
	ON_BOARDING: 'on_boarding',
	QRCODE_SCAN: 'qrcode_scan',
	QRCODE_VALIDATE_BOOKING: 'qrcode_validate_booking',
	QRCODE_TIMESLOT: 'qrcode_timeslot',
	PRESENCE_TRANSPORT: 'presence_transport',
	
	LUNCH_SCANNER: 'lunch_scanner',
	LUNCH_SLEEPING: 'lunch_sleeping',
	
	START_SCAN: 'start_scan',
	START_TRANSPORT: 'start_transport',
	
	BOOKING: 'booking',
	
	INVITATION_RECEIVED: 'invitation_received',
	INVITATION_SENT: 'invitation_sent',
	INVITATION_LOGS: 'invitation_logs',
	
	EVENTS: "events",
	EVENT_VIEW: "event_view",
	
	ADD_BOOKING: 'add_booking',
	ADD_BOOKING_OPTION: 'add_booking_option',
	ADD_BOOKING_SELECT_COWORKER: 'add_booking_select_coworker',
	ADD_BOOKING_VIEW_COWORKER: 'add_booking_view_coworker',
	ADD_BOOKING_LOCATION: 'add_booking_location',
	ADD_BOOKING_LOCATION_2: 'add_booking_location_2',
	ADD_BOOKING_LOCATION_3: 'add_booking_location_3',
	ADD_BOOKING_SELECT_FROM_COWORKER: 'add_booking_select_from_coworker',
	ADD_BOOKING_LUNCH: 'add_booking_lunch',
	ADD_BOOKING_LICENSE_PLATE: 'add_booking_license_plate',
	ADD_BOOKING_DATE: 'add_booking_date',
	ADD_BOOKING_PREVIEW: 'add_booking_preview',
	ADD_BOOKING_OVERVIEW: 'add_booking_overview',
	ADD_BOOKING_SUCCESS: 'add_booking_success',

	COWORKERS: 'coworkers',
	COWORKERS_INDEX: 'coworkers_index',
	COWORKERS_VIEW: 'coworkers_view',
	COWORKERS_FILTER: 'coworkers_filter',
	COWORKERS_FILTER_SELECTION: 'coworkers_filter_selection',
	COWORKERS_FILTER_RESULTS: 'coworkers_filter_results',
	
	MORE: 'more',
	MORE_INDEX: 'more_index',
	MORE_DEBUG: 'more_debug',
	MORE_DEBUG_INTERFACE_ICONS: 'more_debug_interface_icons',
	MORE_DEBUG_VIDEO: 'more_debug_video',
	MORE_PRIVACY: 'more_privacy',
	MORE_ABOUT: 'more_about',
	MORE_PROFILE: 'more_profile',
	MORE_WORKDAYS: 'more_workdays',
	MORE_TRAVEL_HISTORY: 'more_travel_history',
	MORE_TRAVEL_HISTORY_DETAIL: 'more_travel_history_detail',
	MORE_TRAVEL_HISTORY_PROFILE_EDIT: 'more_travel_history_profile_edit',
	MORE_INBOX: "more_inbox",
	MORE_INBOX_VIEW: "more_inbox_view",
	MORE_SETTINGS: 'more_settings',
	MORE_CALENDAR_SUBSCRIPTION: 'more_calendar_subscription',
	MORE_ACCOUNTS: 'more_accounts',

	// Credits
	MORE_CREDITS: 'more_credits',
	MORE_CREDITS_VIEW: 'more_credits_view',
	MORE_CREDITS_TRANSACTIONS: 'more_credits_transactions',
	MORE_CREDITS_ITEM_VIEW: 'more_credits_item_view',
	MORE_CREDITS_BUY: 'more_credits_buy',
	MORE_CREDITS_BUY_PAYMENT: 'more_credits_buy_payment',
	
	INFO: 'info',
	DEBUG: 'debug',
	
	// Global routes
	ERO_COWORKER: 'ero_coworker',
	CONFIDANT_COWORKER: 'confidant_coworker',

	// Web management
	MANAGEMENT_DASHBOARD_GROUP: 'management_dashboard',
	MANAGEMENT_DASHBOARD_INDEX: 'management_dashboard_index',
	
	MANAGEMENT_BOOKINGS_BOOKING: 'management_bookings_booking',
	MANAGEMENT_BOOKINGS_BOOKING_INDEX: 'management_bookings_booking_index',
	
	MANAGEMENT_BOOKINGS_LUNCH: 'management_bookings_lunch',
	MANAGEMENT_BOOKINGS_LUNCH_INDEX: 'management_bookings_lunch_index',
	
	MANAGEMENT_BOOKINGS_TRANSPORT: 'management_bookings_transport',
	MANAGEMENT_BOOKINGS_TRANSPORT_INDEX: 'management_bookings_transport_index',
	
	MANAGEMENT_BOOKINGS_MEETING_ROOM: 'management_bookings_meeting_room',
	MANAGEMENT_BOOKINGS_MEETING_ROOM_INDEX: 'management_bookings_meeting_room_index',
	
	MANAGEMENT_BOOKINGS_ERO: 'management_bookings_ero',
	MANAGEMENT_BOOKINGS_ERO_INDEX: 'management_bookings_ero_index',
	
	MANAGEMENT_BOOKINGS_VALIDATE: 'management_bookings_validate',
	MANAGEMENT_BOOKINGS_VALIDATE_INDEX: 'management_bookings_validate_index',
	
	MANAGEMENT_BOOKINGS_VIEW: 'management_bookings_view',

	MANAGEMENT_PRESENCE: 'management_presence',
	MANAGEMENT_PRESENCE_INDEX: 'management_presence_index',
	MANAGEMENT_PRESENCE_DETAIL: 'management_presence_detail',
	
	MANAGEMENT_QRCODES: 'management_qrcodes',
	MANAGEMENT_QRCODES_INDEX: 'management_qrcodes_index',

	MANAGEMENT_STATISTICS: 'management_statistics',
	MANAGEMENT_STATISTICS_INDEX: 'management_statistics_index',
	
	MANAGEMENT_REPORTS: 'management_reports',
	MANAGEMENT_REPORTS_INDEX: 'management_reports_index',
	MANAGEMENT_REPORTS_SCHEDULE_EDIT: 'management_reports_schedule_edit',

	MANAGEMENT_USERS: 'management_users',
	MANAGEMENT_USERS_INDEX: 'management_users_index',

	MANAGEMENT_EMPLOYEES_TEAMS: 'management_employees_teams',
	MANAGEMENT_EMPLOYEES_TEAMS_INDEX: 'management_employees_teams_index',
	MANAGEMENT_EMPLOYEES_TEAMS_VIEW: 'management_employees_teams_view',
	
	MANAGEMENT_EMPLOYEES_EMPLOYEE_VIEW: 'management_employees_employee_view',
	
	// Edit
	MANAGEMENT_BUILDINGS_BUILDINGS: 'management_buildings_buildings',
	MANAGEMENT_BUILDINGS_BUILDINGS_INDEX: 'management_buildings_buildings_index',
	MANAGEMENT_BUILDINGS_BUILDINGS_VIEW: 'management_buildings_buildings_view',
	
	MANAGEMENT_BUILDINGS_CONTACT: 'management_buildings_contact',
	MANAGEMENT_BUILDINGS_FLOOR: 'management_buildings_floor',
	MANAGEMENT_BUILDINGS_ROOM: 'management_buildings_room',
	
	MANAGEMENT_COMPANY_COMPANIES: 'management_company_companies',
	MANAGEMENT_COMPANY_COMPANIES_INDEX: 'management_company_companies_index',
	MANAGEMENT_COMPANY_COMPANIES_VIEW: 'management_company_companies_view',
	MANAGEMENT_COMPANY_COMPANIES_DEPARTMENT: 'management_company_companies_department',
	
	MANAGEMENT_JOBTITLES_JOBTITLES: 'management_jobtitles_jobtitles',
	MANAGEMENT_JOBTITLES_JOBTITLES_INDEX: 'management_jobtitles_jobtitles_index',
	MANAGEMENT_JOBTITLES_JOBTITLES_VIEW: 'management_jobtitles_jobtitles_view',
	
	MANAGEMENT_APP_MESSAGES: 'management_app_messages',
	MANAGEMENT_APP_MESSAGES_EDIT: 'management_app_messages_edit',
	
	MANAGEMENT_SETTINGS_APP: 'management_settings_app',
	MANAGEMENT_SETTINGS_EMAILS: 'management_settings_emails',
	MANAGEMENT_SETTINGS_EMAILS_EDIT: 'management_settings_emails_edit',
	
	MANAGEMENT_TIMESLOTS: 'management_timeslots',
	MANAGEMENT_TIMESLOT_KINDS_ADD: 'management_timeslot_kinds_add',
	MANAGEMENT_TIMESLOT_KINDS: 'management_timeslot_kinds',
	MANAGEMENT_TIMESLOT_KIND_EXCEPTION_EDIT: 'management_timeslot_kind_exception_edit',
	MANAGEMENT_TIMESLOT_GROUPS: 'management_timeslot_groups',
	
	MANAGEMENT_INFORMATION_MESSAGES: 'management_information_messages',

	MANAGEMENT_CREDIT_BUNDLES: 'management_credit_bundles',
	MANAGEMENT_CREDIT_BUNDLES_EDIT: 'management_credit_bundles_edit',
	MANAGEMENT_CREDIT_BUNDLES_QR: 'management_credit_qr_codes',
	MANAGEMENT_CREDIT_BUNDLES_QR_EDIT: 'management_credit_qr_codes_edit',
}
